export default __webpack_public_path__ + "static/media/flaskFull.ce17cc5c.svg";